import axios from 'axios'
import config from './config';

// Utility function to sanitize parameters
const sanitizeParams = (data) => {
    if (!data || typeof data !== 'object') {
        return null;
    }
    
    const sanitized = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => 
            value !== null && value !== undefined && value !== ''
        )
    );
    
    return Object.keys(sanitized).length > 0 ? sanitized : null;
};


// section For get Browser Details-----------------
const userAgent = navigator.userAgent;
// let browserName = 'Unknown';
// if (userAgent.indexOf('Firefox') > -1) {
//     browserName = 'Mozilla Firefox';
// } else if (userAgent.indexOf('SamsungBrowser') > -1) {
//     browserName = 'Samsung Internet';
// } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
//     browserName = 'Opera';
// } else if (userAgent.indexOf('Trident') > -1) {
//     browserName = 'Microsoft Internet Explorer';
// } else if (userAgent.indexOf('Edge') > -1) {
//     browserName = 'Microsoft Edge';
// } else if (userAgent.indexOf('Chrome') > -1) {
//     browserName = 'Google Chrome';
// } else if (userAgent.indexOf('Safari') > -1) {
//     browserName = 'Apple Safari';
// }
// Section End=---------------------

const serverPath = config.serverPath;

export const request = (path, data, method) => {
    // Read from localStorage instead of cookies to match ProtectedRoute
    let loginData = null;
    try {
        const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
        if (storageData) {
            loginData = JSON.parse(storageData);
        }
    } catch (error) {
        console.error("Error parsing login data from localStorage:", error);
        loginData = null;
    }

    // Fix double slash issue by checking if path already starts with /
    const fullUrl = path.startsWith('/') ? `${serverPath}${path}` : `${serverPath}/${path}`;
    
    // Debug logging removed for production

    var options = {
        method: method,
        url: fullUrl,
        headers: {
            'Content-Type': 'application/json'
        },
        dataType: 'json',
    };
    if (loginData && loginData.authToken) {
        options.headers['Authorization'] = `Bearer ${loginData.authToken}`
        options.headers['browserType'] = userAgent
    }
    if (method === 'GET') {
        // Only set params if data exists and is not null/undefined
        if (data && typeof data === 'object' && Object.keys(data).length > 0) {
            // Sanitize parameters to remove null/undefined values
            const sanitizedParams = Object.fromEntries(
                Object.entries(data).filter(([_, value]) => 
                    value !== null && value !== undefined && value !== ''
                )
            );
            // Only set params if there are valid parameters after sanitization
            if (Object.keys(sanitizedParams).length > 0) {
                options['params'] = sanitizedParams;
            }
        }
    } else {
        options['data'] = data
    }
    let res = axios(options)
    res.then(res1 => { })
    return res
}

export const requestFormData = (path, data, method) => {
    // Read from localStorage instead of cookies
    let loginData = null;
    try {
        const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
        if (storageData) {
            loginData = JSON.parse(storageData);
        }
    } catch (error) {
        console.error("Error parsing login data from localStorage:", error);
        loginData = null;
    }

    var form_data = new FormData();
   
    for (var key in data) {        
        form_data.append(key, data[key]);
    }
    
    // Fix double slash issue
    const fullUrl = path.startsWith('/') ? `${serverPath}${path}` : `${serverPath}/${path}`;
    
    var options = {
        method: method,
        url: fullUrl,
        data: form_data,
        headers:
        {
            authorization: loginData?.authToken ? `Bearer ${loginData.authToken}` : '',
            browserType:userAgent
        },
    };
    let res = axios(options);
    res.then(res1 => { })
    return res
}

export const requestFormDataForImage = (path, data, method) => {
    // Read from localStorage instead of cookies
    let loginData = null;
    try {
        const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
        if (storageData) {
            loginData = JSON.parse(storageData);
        }
    } catch (error) {
        console.error("Error parsing login data from localStorage:", error);
        loginData = null;
    }

    var form_data = new FormData();
    for (var key in data.formValues) {        
        form_data.append(key, data.formValues[key]);
    }

    // Fix double slash issue
    const fullUrl = path.startsWith('/') ? `${serverPath}${path}` : `${serverPath}/${path}`;

    var options = {
        method: method,
        url: fullUrl,
        data: form_data,
        browserType:userAgent,
        headers: {
            authorization: loginData?.authToken ? `Bearer ${loginData.authToken}` : '',
            browserType:userAgent
        },   
    };
    let res = axios(options);
    res.then(res1 => { })
    return res
}

export const requestFormDataWithImage = (path, data, method) => {
    // Read from localStorage instead of cookies
    let loginData = null;
    try {
        const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
        if (storageData) {
            loginData = JSON.parse(storageData);
        }
    } catch (error) {
        console.error("Error parsing login data from localStorage:", error);
        loginData = null;
    }

    // Fix double slash issue
    const fullUrl = path.startsWith('/') ? `${serverPath}${path}` : `${serverPath}/${path}`;

    var options = {
        method: method,
        url: fullUrl,
        data: data,
        headers:
        {
            authorization: loginData?.authToken ? `Bearer ${loginData.authToken}` : '',
            browserType:userAgent
        },
    };
    let res = axios(options);
    res.then(res1 => { })
    return res
}

export const postRequest = async (path, data) => await request(path, data, 'POST')
export const getRequest = async (path, data) => await request(path, data, 'GET')
export const putRequest = async (path, data) => await request(path, data, 'PUT')
export const deleteRequest = async (path, data) => await request(path, data, 'DELETE')
export const postRequestFormData = async (path, data) => await requestFormData(path, data, 'POST')
export const postrequestFormDataForImage = async (path, data) => await requestFormDataForImage(path, data, 'POST')
export const postRequestFormDataWithImage = async (path, data) => await requestFormDataWithImage(path, data, 'POST')
